/**
 * Supabase client initialization for i99.
 *
 * Ready for connection – set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY
 * in your .env file (see .env.example).
 *
 * Usage:
 *   import { supabase } from '@/lib/supabase';
 *   const { data, error } = await supabase.from('businesses').select('*');
 */

import { createClient } from '@supabase/supabase-js';

const supabaseUrl  = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey  = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseKey) {
  console.warn(
    '[i99/supabase] Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY. ' +
    'Copy .env.example → .env and fill in your Supabase credentials.'
  );
}

export const supabase = createClient(
  supabaseUrl  ?? 'https://placeholder.supabase.co',
  supabaseKey  ?? 'placeholder-anon-key',
  {
    auth: {
      persistSession:     true,
      autoRefreshToken:   true,
      detectSessionInUrl: true,
      // Implicit flow avoids PKCE code-verifier issues when the magic link
      // is opened in a different browser or email client than where it was
      // requested (e.g. Gmail opens links in its own in-app browser).
      flowType: 'implicit',
    },
  }
);

export default supabase;
